// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"94b223dc","369":"0b318118","513":"6d24a0af","703":"0e344c07","921":"37ce1c64"}[chunkId] + ".chunk.js";
};